module.exports = __webpack_public_path__ + "img/prueba2.e0bc03ef.png";